import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	previewLabel: {
		id: 'language-settings.preview-send-test-email-actions.preview-label',
		defaultMessage: 'Preview',
		description: 'Label for the preview button of the customer notification page',
	},
	previewModalTitle: {
		id: 'language-settings.preview-send-test-email-actions.preview-modal-title',
		defaultMessage: 'Message preview',
		description: 'Modal title for the preview dropdown items modal',
	},
	menuLabel: {
		id: 'language-settings.preview-send-test-email-actions.menu-label',
		defaultMessage: 'More',
		description: 'MoreIcon label for the Action dropdown',
	},
});
